import { render } from "./ProfileFormPassword.vue?vue&type=template&id=07007dd7&scoped=true"
import script from "./ProfileFormPassword.vue?vue&type=script&lang=js"
export * from "./ProfileFormPassword.vue?vue&type=script&lang=js"

import "./ProfileFormPassword.vue?vue&type=style&index=0&id=07007dd7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07007dd7"]])

export default __exports__